export default __webpack_public_path__ + "static/media/mobile_language_options_image_uk.578c99a8.png";